export default "__VITE_ASSET__CTrh582i__"